var map = {
	"./en/account.json": [
		"./src/main/webapp/i18n/en/account.json",
		0
	],
	"./en/common.json": [
		"./src/main/webapp/i18n/en/common.json",
		1
	],
	"./en/driver.json": [
		"./src/main/webapp/i18n/en/driver.json",
		2
	],
	"./en/global.json": [
		"./src/main/webapp/i18n/en/global.json",
		3
	],
	"./en/healthcare-facility.json": [
		"./src/main/webapp/i18n/en/healthcare-facility.json",
		4
	],
	"./en/home.json": [
		"./src/main/webapp/i18n/en/home.json",
		5
	],
	"./en/journey.json": [
		"./src/main/webapp/i18n/en/journey.json",
		6
	],
	"./en/patient-baby.json": [
		"./src/main/webapp/i18n/en/patient-baby.json",
		7
	],
	"./en/patient-outcome.json": [
		"./src/main/webapp/i18n/en/patient-outcome.json",
		8
	],
	"./en/patient-visit.json": [
		"./src/main/webapp/i18n/en/patient-visit.json",
		9
	],
	"./en/patient.json": [
		"./src/main/webapp/i18n/en/patient.json",
		10
	],
	"./en/payment.json": [
		"./src/main/webapp/i18n/en/payment.json",
		11
	],
	"./en/physician.json": [
		"./src/main/webapp/i18n/en/physician.json",
		12
	],
	"./en/route.json": [
		"./src/main/webapp/i18n/en/route.json",
		13
	],
	"./en/symptom.json": [
		"./src/main/webapp/i18n/en/symptom.json",
		14
	],
	"./en/user-management.json": [
		"./src/main/webapp/i18n/en/user-management.json",
		15
	],
	"./en/vehicle-type.json": [
		"./src/main/webapp/i18n/en/vehicle-type.json",
		16
	],
	"./en/village.json": [
		"./src/main/webapp/i18n/en/village.json",
		17
	],
	"./en/watotocare-entity.json": [
		"./src/main/webapp/i18n/en/watotocare-entity.json",
		18
	],
	"./en/watotocare-settings.json": [
		"./src/main/webapp/i18n/en/watotocare-settings.json",
		19
	],
	"./st/account.json": [
		"./src/main/webapp/i18n/st/account.json",
		20
	],
	"./st/common.json": [
		"./src/main/webapp/i18n/st/common.json",
		21
	],
	"./st/driver.json": [
		"./src/main/webapp/i18n/st/driver.json",
		22
	],
	"./st/global.json": [
		"./src/main/webapp/i18n/st/global.json",
		23
	],
	"./st/healthcare-facility.json": [
		"./src/main/webapp/i18n/st/healthcare-facility.json",
		24
	],
	"./st/home.json": [
		"./src/main/webapp/i18n/st/home.json",
		25
	],
	"./st/journey.json": [
		"./src/main/webapp/i18n/st/journey.json",
		26
	],
	"./st/patient-baby.json": [
		"./src/main/webapp/i18n/st/patient-baby.json",
		27
	],
	"./st/patient-outcome.json": [
		"./src/main/webapp/i18n/st/patient-outcome.json",
		28
	],
	"./st/patient-visit.json": [
		"./src/main/webapp/i18n/st/patient-visit.json",
		29
	],
	"./st/patient.json": [
		"./src/main/webapp/i18n/st/patient.json",
		30
	],
	"./st/payment.json": [
		"./src/main/webapp/i18n/st/payment.json",
		31
	],
	"./st/physician.json": [
		"./src/main/webapp/i18n/st/physician.json",
		32
	],
	"./st/route.json": [
		"./src/main/webapp/i18n/st/route.json",
		33
	],
	"./st/symptom.json": [
		"./src/main/webapp/i18n/st/symptom.json",
		34
	],
	"./st/user-management.json": [
		"./src/main/webapp/i18n/st/user-management.json",
		35
	],
	"./st/vehicle-type.json": [
		"./src/main/webapp/i18n/st/vehicle-type.json",
		36
	],
	"./st/village.json": [
		"./src/main/webapp/i18n/st/village.json",
		37
	],
	"./st/watotocare-entity.json": [
		"./src/main/webapp/i18n/st/watotocare-entity.json",
		38
	],
	"./st/watotocare-settings.json": [
		"./src/main/webapp/i18n/st/watotocare-settings.json",
		39
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/main/webapp/i18n lazy recursive ^\\.\\/.*\\/.*\\.json$";
module.exports = webpackAsyncContext;